const state = {
  items: [],
}

const getters = {
  count: state => {
    return state.items.length;
  },
  getById: (state) => (id) => {
    return state.items.find(item => item.id == id);
  },
  getAll: (state) => {
    return state.items;
  },
  getByIdTorneo: (state) => (id, id_torneo) => {
    return state.items.find(item => item.id == id && item.id_torneo == id_torneo);
  }
}

const actions = {

  retrieveFromLS ({ commit }) {
    let items = JSON.parse(localStorage.getItem('db.equipos'));
    if (items) commit('setItems', items);
  },

  setAndPersistLS({ dispatch, commit }, items) {
    commit('setItems', items);
    dispatch('persistLS');
  },

  persistLS({ state }) {
    localStorage.setItem('db.equipos', JSON.stringify(state.items));
  }
}


const mutations = {
  setItems (state, items) {
    state.items = items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}